import { net_api_url } from 'components/Store';
import axios from 'axios';
const getCurrentUser = async (getAccessToken, source) => {
  try {
    let token = await getAccessToken();
    let currentUser = await axios.get(`${net_api_url}/api/user/getcurrent`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      signal: source?.signal,
    });
    let currentUserInformation = currentUser.data;
    return currentUserInformation;
  } catch (error) {
    if (error.name === 'CanceledError') {
      console.error(error?.config?.signal?.reason);
    } else {
      console.error(error);
    }
  }
};

export default getCurrentUser;
